// AUTO-GENERATED from articles.ts split — metadata only (no body).
// Imported by homepage / archive / card lists; bodies live in articles-bodies.ts
// and are lazy-loaded only by slug routes.

export type ArticleMeta = {
  slug: string;
  magazine: string;
  date: string;
  isoDate: string;
  title: string;
  dek: string;
  excerpt: string;
};

export const articlesMeta: ArticleMeta[] = [
  {
    "slug": "the-diplomats-last-message",
    "magazine": "Centre",
    "date": "Global Affairs",
    "isoDate": "2025-10-01",
    "title": "The Diplomat's Last Message",
    "dek": "Nearly a year after Henry Kissinger's passing at the age of 100, his final book, \"Genesis: Artificial Intelligence, Hope, and the Human Spirit,\" co-authored with Craig Mundie and Eric Schmidt, has been published. Kissinger explores how AI can empower humanity while posing profound questions about our collective future.",
    "excerpt": "Kissinger's final book Genesis maps six scenarios for the AI age and asks how humanity will evolve alongside machines that may soon surpass us."
  },
  {
    "slug": "two-suns-in-the-sky",
    "magazine": "Centre",
    "date": "Global Affairs",
    "isoDate": "2025-06-01",
    "title": "Two Suns In The Sky",
    "dek": "\"There cannot be two suns in the sky, nor two emperors on Earth.\" — Confucius. As the Red Dragon rises with methodical precision, an ancient principle resurfaces — not as myth, but as method.",
    "excerpt": "Through infrastructure, influence, and information, China advances a new mandate. A liminal century unfolds between paradigms, between empires, between certainties."
  },
  {
    "slug": "kizil-ejderin-sahlanisi",
    "magazine": "Centre",
    "date": "Nisan 2025",
    "isoDate": "2025-04-01",
    "title": "Kızıl Ejderin Şahlanışı: Amerikan Yüzyılının Sonu mu?",
    "dek": "\"Gökyüzünde iki güneş, yeryüzünde iki imparator olamaz.\" — Konfüçyüs. Batı'nın öncülüğünde şekillenen liberal uluslararası düzen çözülürken, merkezde giderek daha güçlü ve iddialı bir aktör var: Çin.",
    "excerpt": "Kuşak ve Yol'dan Dijital İpek Yolu'na, yapay zekâdan BRICS+ genişlemesine; çok kutuplu yeni dünya düzeninin haritası."
  },
  {
    "slug": "pazarlama-nereye-gidiyor",
    "magazine": "The Brand Map",
    "date": "Ocak 2026",
    "isoDate": "2026-01-01",
    "title": "Pazarlama Nereye Gidiyor? İnsan Nerede Kalıyor?",
    "dek": "Pazarlama giderek sistem optimizasyonuna gömülüyor. Üstelik, artık yalnızca insanlar değil, makineler de tüketici haline geliyor. Bu noktada pazarlamanın tarihsel rolü değişiyor: Özne üretimi.",
    "excerpt": "Algoritmaların kararı, sembolik anlatının kimliği, yavaş emeğin direnci… Üç farklı özne rejimi üzerinden pazarlamanın yeni rolünü sorguluyorum."
  },
  {
    "slug": "holokosttan-yapay-zeka-cagina",
    "magazine": "The Brand Map",
    "date": "Kasım 2025",
    "isoDate": "2025-11-01",
    "title": "Holokost'tan Yapay Zekâ Çağı'na: Etik Mesafenin Önemi",
    "dek": "İnsanlık tarihinin en karanlık tasarımı; teknolojik rasyonalitenin, kurumsal itaatin ve etik mesafenin birleştiği noktada insanlığın nasıl un ufak olabileceğinin kanıtıdır. Bugün, yapay zekâ çağında, o ders yeniden önümüzde duruyor.",
    "excerpt": "Bauman ve Arendt'in ışığında, bürokratik itaatten algoritmik karara: Etik sorumluluk çözüldüğünde sistemler nasıl yıkıcı hale gelir?"
  },
  {
    "slug": "rashomon-etkisi-ve-doga",
    "magazine": "The Brand Map",
    "date": "Temmuz 2025",
    "isoDate": "2025-07-01",
    "title": "Rashomon Etkisi ve Doğa: Hakikat Çözülürken, Etik İhtiyaç Artıyor",
    "dek": "Kurosawa'nın başyapıtı bir cinayetin değil, hakikatin göreli doğasının hikâyesidir. Çevre krizinde hakikati birlikte inşa etmenin zamanı.",
    "excerpt": "Hakikat parçalandığında ne yapacağız? Kurosawa'nın Rashomon'undan çevre etiğine, çoklu gerçeklikler içinde ortak bir zemin arayışı."
  },
  {
    "slug": "sonsuz-optimizasyon-mitine-direnis",
    "magazine": "The Newsight",
    "date": "22 Temmuz 2025",
    "isoDate": "2025-07-22",
    "title": "Sonsuz Optimizasyon Mitine Direniş: Yeterlilik Etiği",
    "dek": "Sürdürülebilirlik retoriği çöktü; ama mevcut sistemin de taşıma gücü kalmadı. Verimlilik fetişizmine karşı bir 'yeterlilik etiği' çağrısı.",
    "excerpt": "Heidegger ve Latour'dan yola çıkarak, yapay zekânın körüklediği sonsuz optimizasyon mitine karşı yeterlilik etiğini tartışıyoruz."
  },
  {
    "slug": "algoritmik-doga",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-05-01",
    "title": "Algoritmalarla Yeniden Yazılan Doğa",
    "dek": "Kuantum bilgisayarların yüksek işleme kapasitesiyle doğanın algoritmik ikizinin yapılması, ontolojik bir dönüşümü beraberinde getiriyor.",
    "excerpt": "Doğayı gerçekten anlıyor muyuz, yoksa onu yalnızca sayısal parametreler ve algoritmalar çerçevesinde yeniden mi inşa ediyoruz?"
  },
  {
    "slug": "dijital-leviathan",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-03-01",
    "title": "Dijital Leviathan ve Sürdürülebilir Toplum Sözleşmesi",
    "dek": "Hobbes'un Leviathan'ı fiziksel egemenle toplumu kontrol ediyordu. Dijital Leviathan ise algoritmaların arkasına saklanan yeni bir otorite.",
    "excerpt": "Algoritmaların egemenliği çağında bireyin haklarını, toplumsal dayanışmayı ve doğanın bütünlüğünü gözeten yeni bir toplum sözleşmesi mümkün mü?"
  },
  {
    "slug": "filtrelenen-kiyamet",
    "magazine": "The Newsight",
    "date": "16 Aralık 2024",
    "isoDate": "2024-12-16",
    "title": "Filtrelenen Kıyamet: Toksik Dijital Estetizm",
    "dek": "Instagram'da milyonlarca beğeni toplayan o kareler, ekolojik felaketin dijital estetikle makyajlanarak performansa ve 'sanata' dönüşmüş hali.",
    "excerpt": "Kirlilik estetiği, post modern kapitalizmin felaketleri bile tüketilebilir metaya çevirme becerisinin son örneği. Asıl mücadele algı manipülasyonuna karşı."
  },
  {
    "slug": "kayitsizligin-dikenli-tahti",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-02-01",
    "title": "Ölü Vicdanlar, Sağır Kulaklar: Kayıtsızlık ve Çürüme",
    "dek": "Vicdanî sorumluluk anlayışının gündelik hayatta karşılığını bulmakta zorlandığı, başkalarının acısını tüketilebilir içeriğe çevirdiğimiz bir çağ.",
    "excerpt": "Mega kentlerin yalnızlığı, gösteri toplumu ve dijital anestezi: kayıtsızlık kültürünün anatomisi ve çürüme döngüsünü kırma yolları."
  },
  {
    "slug": "surdurulebilirlik-fetisizmi",
    "magazine": "The Newsight",
    "date": "2024",
    "isoDate": "2024-11-01",
    "title": "Sürdürülebilirlik Fetişizmi ve Ekolojik Burjuvazi",
    "dek": "Baudrillard'ın simülasyonu ile Marx'ın meta fetişizmini harmanlayan bir bakış: sürdürülebilirlik kavramı yeni bir metaya dönüşüyor.",
    "excerpt": "Ekolojik simülasyon, yeşil etiketli metalaştırma ve 'ekolojik burjuvazi' habitusu: radikal bir alternatif neden zorunlu?"
  },
  {
    "slug": "kuresel-ikiyuzluluk",
    "magazine": "The Newsight",
    "date": "10 Aralık 2024",
    "isoDate": "2024-12-10",
    "title": "Küresel İkiyüzlülük: Sürdürülebilirlik",
    "dek": "Bir yanda parlak sürdürülebilirlik raporları, diğer yanda her geçen gün kötüleşen çevresel göstergeler. Bu kolektif kendini kandırmanın anatomisi.",
    "excerpt": "Verilerle ortaya konulan bir tablo: ekolojik ve sosyal krizler arasındaki derin bağ ve gerçek sürdürülebilirliğin yol haritası."
  },
  {
    "slug": "kuantum-felsefesi-ve-yapay-zeka",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-01-15",
    "title": "Kuantum Felsefesi ve Yapay Zeka: Geleceğin Dünyasına Yolculuk",
    "dek": "Kuantum felsefesi ve yapay zeka ortak bir noktada buluşuyor: gerçeklik, zeka ve bilinç kavramlarını yeniden sorgulamak.",
    "excerpt": "Belirsizlik ilkesinden Schrödinger'in kedisine, Turing testinden Çin Odası'na: makineler gerçekten 'düşünebilir' mi?"
  },
  {
    "slug": "atom-alti-parcaciklar",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-01-01",
    "title": "Atom Altı Parçacıklar, Kuantum Fiziği ve Enerjinin Gizemi",
    "dek": "Görmediğimiz şeyler, gördüğümüz her şeyi yönetir. Atom altı dünyanın şaşırtıcı kuralları ve enerjinin ardındaki büyük resim.",
    "excerpt": "Çift yarık deneyinden Einstein'ın E=mc² formülüne, atom altı parçacıkların \"garip\" davranışları evrenin işleyişine ışık tutuyor."
  },
  {
    "slug": "where-is-marketing-going",
    "magazine": "The Brand Map",
    "date": "January 2026",
    "isoDate": "2026-01-01",
    "title": "Where Is Marketing Going? Where Does the Human Remain?",
    "dek": "Marketing is sinking ever deeper into system optimization. And it is no longer only humans who consume — machines have become consumers too. At this point marketing's historical role is changing: the production of subjects.",
    "excerpt": "Algorithmic decision-making, symbolic narrative identity, and the resistance of slow labor — three regimes of subject-production through which I question the new role of marketing."
  },
  {
    "slug": "dead-consciences-deaf-ears",
    "magazine": "The Newsight",
    "date": "2025",
    "isoDate": "2025-02-01",
    "title": "Dead Consciences, Deaf Ears: Indifference and Decay",
    "dek": "An age in which our sense of moral responsibility struggles to find any foothold in daily life, and in which we turn other people's pain into consumable content.",
    "excerpt": "The loneliness of mega-cities, the society of the spectacle and digital anesthesia: an anatomy of the culture of indifference and ways to break the cycle of decay."
  }
];

const EN_SLUGS = new Set([
  "the-diplomats-last-message",
  "two-suns-in-the-sky",
  "where-is-marketing-going",
  "dead-consciences-deaf-ears",
]);

export function getArticleLang(slug: string): "en" | "tr" {
  return EN_SLUGS.has(slug) ? "en" : "tr";
}

export function getArticleMeta(slug: string): ArticleMeta | undefined {
  return articlesMeta.find((a) => a.slug === slug);
}

export function articlesByLang(lang: "en" | "tr"): ArticleMeta[] {
  return articlesMeta
    .filter((a) => getArticleLang(a.slug) === lang)
    .sort((a, b) => b.isoDate.localeCompare(a.isoDate));
}

export const HOMEPAGE_SLUGS: Record<"en" | "tr", string[]> = {
  tr: [
    "pazarlama-nereye-gidiyor",
    "kayitsizligin-dikenli-tahti",
    "kizil-ejderin-sahlanisi",
  ],
  en: [
    "where-is-marketing-going",
    "dead-consciences-deaf-ears",
    "two-suns-in-the-sky",
  ],
};

export function homepageArticles(lang: "en" | "tr"): ArticleMeta[] {
  const slugs = HOMEPAGE_SLUGS[lang];
  return slugs
    .map((s) => articlesMeta.find((a) => a.slug === s))
    .filter((a): a is ArticleMeta => Boolean(a));
}
